import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../assets/css/gapsy-dashboard.module.css';
import Header from './gapsy-header';
import Footer from './gapsy-footer';

const NotFound = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const customMessage = location.state?.message;
    const found = location.state?.found;

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <div className="text-center mt-5">
                <h1> {found || "404 - Page Not Found"}</h1>
                <p>{customMessage || "The page you're trying to access doesn't exist or you're not authorized."}</p>
                <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
                    Go Back
                </button>
            </div>
            <Footer />
        </div>
    );
};

export default NotFound;
